import '.ff{height:18rem;}.ssr-plugin'
import '.a9{width:100%;}.ssr-plugin'
import '.fg{border-radius:1.875rem 1.875rem 0 0;}.ssr-plugin'
import '.de{background:var(--gray-100);}.ssr-plugin'
import '.fh{border:1px solid var(--gray-200);}.ssr-plugin'
import '.fi{border-radius:0 0 1.875rem 1.875rem;}.ssr-plugin'
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import { CardWrapper } from '../card/CardWrapper'
import { PageHeader, ProfileProps } from './PageHeader'
import { styled } from 'inlines'
import { AvatarStack, ProfileAvatar } from '../avatarStack/AvatarStack'
import { lazy, Suspense } from 'react'
import { TagProps } from '@app/components/core/tag/Tag'
import { ButtonProps } from '@app/components/core/button/Button'
import { ClientOnly } from '../clientOnly/ClientOnly'

const MultiMarkerMap = lazy(() =>
  import('@app/components/core/map/MultiMarkerMap').then((module) => ({
    default: module.MultiMarkerMap,
  })),
)

export type MapCoordinates = {
  lat: number
  long: number
}

const DEFAULT_COORDINATES: MapCoordinates = { lat: 52.1005, long: 5.6465 }
const DEFAULT_ZOOM = 8

export type MapPageHeaderProps = {
  title: string
  subtitle?: string
  buttons?: ButtonProps[]
  tags?: TagProps[]
  hasBadge?: boolean
  profile?: ProfileProps
  followers?: ProfileAvatar[]
  totalFollowers?: number
  onClick?: () => void
  coordinates?: MapCoordinates
  zoom?: number
}

export type HeaderIconProps = {
  icon: IconDefinition
  size: 'small' | 'medium' | 'large' | 'xlarge'
  position: 'left' | 'right'
  color?: string
}

const fallback = (
  <div className="ff a9 fg de"
  />
)

export const MapPageHeader = ({
  title,
  subtitle,
  buttons,
  tags,
  hasBadge,
  profile,
  followers,
  totalFollowers,
  onClick,
  coordinates = DEFAULT_COORDINATES,
  zoom = DEFAULT_ZOOM,
}: MapPageHeaderProps) => {
  return (
    <CardWrapper style={{ padding: '0', border: 0 }}>
      <Suspense fallback={fallback}>
        <ClientOnly fallback={fallback}>
          <MultiMarkerMap
            viewpoint={coordinates}
            zoom={zoom}
            height="18rem"
            style={{
              borderRadius: '1.875rem 1.875rem 0 0',
            }}
          />
        </ClientOnly>
      </Suspense>
      <div className="fh fi"
      >
        <PageHeader
          title={title}
          subtitle={subtitle}
          tags={tags}
          buttons={buttons}
          hasBadge={hasBadge}
          style={{ padding: '1.5rem 1.5rem 0 1.5rem' }}
          onClick={onClick}
          profile={profile}
        />
        {followers && (
          <Row
            style={{
              alignItems: 'center',
              gap: '0.75rem',
              paddingLeft: '1.5rem',
              paddingRight: '1.5rem',
              paddingBottom: '1.5rem',
            }}
          >
            <AvatarStack
              size={'extra-small'}
              avatars={followers}
              total={totalFollowers}
            />
          </Row>
        )}
      </div>
    </CardWrapper>
  )
}
